import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const MyVoucherCodes: Site = {
  id: 'myvouchercodes',
  logo: 'svg/myvouchercodes.svg',
  label: 'MyVoucherCodes',
  analyticsName: 'myvouchercodes',
  hostname: 'myvouchercodes.co.uk',
  hostnameStage: 'mvc-staging.tgvg.io',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
